import { useParams } from 'react-router-dom'
import { useUser } from '@supabase/auth-helpers-react'
import { Loader } from '@mantine/core'
import useSWR from 'swr'

import ScrollableScreen from '@/components/ui/ScrollableScreen'
import ProfileSettings from '@/components/profiles/ProfileSettings'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function Profile() {
    const { profile_id } = useParams()
    const user = useUser()
    const { requestGet } = useAxiosApi()

    const { data, isLoading, mutate } = useSWR(
        profile_id ? `/profiles/${profile_id}` : null,
        requestGet,
    )
    const profile = data?.data?.profile
    const isOwnProfile = user?.id === profile_id

    const breadcrumbs = [
        {
            label: 'Utilisateurs',
            href: '/profiles',
        },
        {
            label: profile?.name,
        },
    ]

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            {isLoading || !profile ? (
                <div className="flex items-center justify-center p-12">
                    <Loader />
                </div>
            ) : (
                <ProfileSettings
                    profile={profile}
                    isOwnProfile={isOwnProfile}
                    onMutate={mutate}
                />
            )}
        </ScrollableScreen>
    )
}
